import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var pendingDispatchRes;
export const pendingDispatchTodo = createAsyncThunk('pendingDispatch', async (data) => {
    // console.log("data", data)
    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'dashboard_pending_despatch',
            headers: { "Content-Type": "application/json" },
            data: {
                "vcust_plant_code": localStorage.getItem('vcust_plant_code')
            }
        })
        return pendingDispatchRes = res.data

    } catch (error) {
        return pendingDispatchRes = error.response.data
    }
});

const pendingDispatchSlice = createSlice({
    name: 'pendingDispatch',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(pendingDispatchTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(pendingDispatchTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default pendingDispatchSlice.reducer; 